import { createPageTableSchema } from '@state/_shared/tableComponentStateSchema';

// Row shape for items shown in the batch details dialog table. Shared by every
// page that renders <BatchDetailsDialog /> (batches, catalog, stow inventory).
const batchItemRowSchema = {
    type: 'object',
    properties: {
        id: { type: 'string' },
        batch_id: { type: ['number', 'string'] },
        user_inventory_item_id: { type: ['number', 'null'], default: null },
        condition: { type: 'string' },
        qty: { type: 'number' },
        price: { type: ['number', 'string', 'null'], default: null },
        is_stowed: { type: 'boolean', default: false },
        is_listed: { type: 'boolean', default: false },
        createdAt: { type: ['string', 'null'], default: null },
        updatedAt: { type: ['string', 'null'], default: null },
        image_url: { type: ['string', 'null'], default: null },
        lot: { type: ['object', 'null'], default: null },
        location: { type: ['object', 'null'], default: null },
    },
};

// Shared schema for the batch details dialog. The `table` subtree is mandatory:
// the shared useBatchDetailsTableHandler writes batchDetailsDialog.table.* paths
// (isLoading, rows, totalItems, pagination, sorting) the moment the dialog opens.
export const batchDetailsDialogStateSchema = {
    type: 'object',
    properties: {
        isOpen: {
            type: 'boolean',
            default: false
        },
        isLoadingItems: {
            type: 'boolean',
            default: false
        },
        table: createPageTableSchema(batchItemRowSchema)
    }
};
